import {
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography,
} from '@mui/material'
import {
    MapPaymentIcon,
    mapPaymentTypeName,
} from 'components/MapPaymentIcon/mapPaymentIcon'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import { IPaymentTypeSelection } from '../hook/usePaymentContext'
import { PAYMENT_TYPE_ID } from 'constant/paymentType'

interface PaymentTypeListProps {
    paymentTypeList: IPaymentTypeSelection[]
    onSelect: (paymentSettingID: string) => void
    selectedPaymentSettingID: string | undefined
    onExitAddTipsMode: () => void
    isNegativeTotalDue: boolean
    expectAmount: number
}
export function PaymentTypeList({
    paymentTypeList,
    onSelect,
    selectedPaymentSettingID,
    onExitAddTipsMode,
    isNegativeTotalDue,
    expectAmount,
}: PaymentTypeListProps) {
    const handleListItemClick = (paymentSettingID: string) => {
        onSelect(paymentSettingID)
        onExitAddTipsMode()
    }
    const { isSmallBoxSizeForPaymentTypeBox } = useScreenSize()

    return (
        <List style={{ padding: 0 }}>
            {paymentTypeList.map((l) => {
                return (
                    <ListItem
                        sx={{ p: 0 }}
                        key={`Payment-Type-List-${l.paymentSettingID}`}
                    >
                        <ListItemButton
                            sx={{
                                marginBottom: '5px',
                                height: 100,
                            }}
                            selected={
                                selectedPaymentSettingID === l.paymentSettingID
                            }
                            onClick={() => {
                                handleListItemClick(l.paymentSettingID!)
                            }}
                            disabled={
                                // In case of Negative Total Due -> CASH only
                                (isNegativeTotalDue &&
                                    l.paymentTypeID !== PAYMENT_TYPE_ID.CASH) ||
                                l.disabled(expectAmount)
                            }
                        >
                            <ListItemIcon>
                                <MapPaymentIcon
                                    customLogoUrl={l.customLogoUrl!}
                                    paymentTypeId={l.paymentTypeID!}
                                ></MapPaymentIcon>
                            </ListItemIcon>
                            <ListItemText
                                disableTypography
                                primary={
                                    <Typography
                                        style={{ padding: 0 }}
                                        variant={
                                            isSmallBoxSizeForPaymentTypeBox
                                                ? 'body2'
                                                : 'h6'
                                        }
                                    >
                                        {mapPaymentTypeName(
                                            l.paymentTypeID!,
                                            true,
                                            { paymentSetting: l },
                                        )}
                                    </Typography>
                                }
                            />
                        </ListItemButton>
                    </ListItem>
                )
            })}
        </List>
    )
}
